import React, { useEffect, useRef, useState } from "react";
import Pages from "../route/Index";
import Sidebar from "./sidebar/Sidebar";
import Head from "./head/Head";
import Header from "./header/Header";
import menu from "./menu/MenuData";
import classNames from "classnames";
import LeftPanel from "./left-panel/LeftPanel";
import AppHeader from "./header/AppHeader";
import { getPublicUrl } from "../utils/Utils";
import WorkInProgressBanner from "../components/WorkInProgressBanner";

const Layout = () => {
  //Sidebar
  const [appComponent, setappComponent] = useState();
  const [mobileView, setMobileView] = useState();
  const [visibility, setVisibility] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try {
      return window.localStorage.getItem("adminSidebarCollapsed") === "1";
    } catch {
      return false;
    }
  });
  const [themeState] = useState({
    main: "default",
    sidebar: "white",
    apps: "theme",
    header: "white",
    skin: "light",
  });

  useEffect(() => {
    // Do not wipe body.className — it clears admin-sidebar-collapsed mid-session.
    const body = document.body;
    body.classList.add("nk-body", "has-sidebar", "no-touch", "nk-nio-theme");
    // LeftPanel (apps rail) is hidden; has-apps-sidebar would shift the nav and overlap content.
    body.classList.remove("has-apps-sidebar");
    if (themeState.skin === "dark") body.classList.add("dark-mode");
    else body.classList.remove("dark-mode");

    const apps = menu.find((item) => item.text === "Applications");
    const matched = Array.isArray(apps?.subMenu)
      ? apps.subMenu.find((sub) => getPublicUrl(sub.link) === window.location.pathname)
      : undefined;
    if (matched) {
      setappComponent(matched);
      body.classList.remove("npc-default", "npc-apps-chat", "npc-apps-calendar", "npc-apps-messages");
      body.classList.add("npc-apps", "apps-only", "bg-white", `npc-apps-${matched.link.split("-")[1]}`);
    } else {
      setappComponent(undefined);
      body.classList.remove(
        "npc-apps",
        "apps-only",
        "bg-white",
        "npc-apps-chat",
        "npc-apps-calendar",
        "npc-apps-messages"
      );
      body.classList.add("npc-default");
    }
    const collapsed = Boolean(sidebarCollapsed) && !mobileView;
    body.classList.toggle("admin-sidebar-collapsed", collapsed);
  }, [window.location.pathname, themeState.skin, sidebarCollapsed, mobileView]); // eslint-disable-line react-hooks/exhaustive-deps

  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    const viewChange = () => {
      if (!mountedRef.current) return;
      if (window.innerWidth < 1200) {
        setMobileView(true);
      } else {
        setMobileView(false);
        setVisibility(false);
      }
    };
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    return () => {
      mountedRef.current = false;
      window.removeEventListener("load", viewChange);
      window.removeEventListener("resize", viewChange);
    };
  }, []);

  useEffect(() => {
    const collapsed = Boolean(sidebarCollapsed) && !mobileView;
    document.body.classList.toggle("admin-sidebar-collapsed", collapsed);
    try {
      window.localStorage.setItem("adminSidebarCollapsed", sidebarCollapsed ? "1" : "0");
    } catch {
      /* ignore */
    }
  }, [sidebarCollapsed, mobileView]);

  // function to toggle sidebar
  const toggleSidebar = (e) => {
    e.preventDefault();
    if (mobileView) {
      setVisibility((v) => !v);
      return;
    }
    setSidebarCollapsed((c) => !c);
  };

  const sidebarClass = classNames({
    "nk-sidebar-mobile": mobileView,
    "nk-sidebar-active": visibility && mobileView,
  });

  return (
    <React.Fragment>
      <Head title="Loading" />
      <div className="nk-app-root">
        <LeftPanel theme={themeState.apps} />
        <div className="nk-main">
          <div className="nk-wrap">
            {appComponent ? (
              <React.Fragment>
                <AppHeader fixed theme={themeState.header} app={appComponent} sidebarToggle={toggleSidebar} setVisibility={setVisibility}/>
                {visibility && (
                  <Sidebar sidebarToggle={toggleSidebar} theme={themeState.sidebar} mobileView={mobileView} className={sidebarClass} />
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                 <Header fixed theme={themeState.header} sidebarToggle={toggleSidebar} setVisibility={setVisibility}/>
                <Sidebar
                  sidebarToggle={toggleSidebar}
                  theme={themeState.sidebar}
                  className={sidebarClass}
                  mobileView={mobileView}
                />
              </React.Fragment>
            )}
            <WorkInProgressBanner />
            {visibility && mobileView && <div className="nk-sidebar-overlay" onClick={toggleSidebar}></div>}
            <Pages />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Layout;
